// extracted by mini-css-extract-plugin
export var actionText = "_j4-4";
export var container = "_j4-0";
export var leftSection = "_j4-1";
export var rightSection = "_j4-2";
export var settingsButton = "_j4-6";
export var settingsIcon = "_j4-7";
export var shortcut = "_j4-5";
export var shortcutGroup = "_j4-3";